// extracted by mini-css-extract-plugin
export var cardLayout = "_8l-1";
export var paginationContainer = "_8l-0";